import './maintenance-page.scss';
import ErrorIcon from '../../../assets/icons/UI/icons/maintenance-error.svg';
import KMQHeader from "../../Headers/KMQHeader";

const MaintenancePage = () => {
  return <div className={'maintenance-page'}>
    <KMQHeader/>

    <div className={'maintenance-page-body'}>
      <img
        src={ErrorIcon}
        alt={'error'}
        className={'maintenance-page-body-icon'}
      />
      <div className={'maintenance-page-body-title'}>
        Platform Unavailable!
      </div>
      <div className={'maintenance-page-body-text'}>
        Thank you for your patience! We're currently undergoing a temporary fix and will be back up and running shortly, with even more improvements! We appreciate your understanding and can't wait to serve you better.
      </div>

    </div>
  </div>
}

export default MaintenancePage;